import React from "react";
import ReactPlayer from 'react-player';
import Const from '../components/Const';
import { setUnsupportedVideoCodecMessage, setUnsupportedVideoAudioMessage } from '../components/Utils';
import { isTabletLandscapeLayout, isDesktop, isiOSPlatform } from './AppUtils';
import { getPostMediaDescriptor } from './PostUtils';

export function renderVideoPlayer(url, styleObj, videoClass, muted, that, instance, config = {}, props = {}) {
  const onErrorHandle = (event) => {
    if (that && that.parent) {
      // for video preview only
      if (event.srcElement && event.srcElement.error && event.srcElement.error.message) {
        if (event.srcElement.error.message.toLowerCase().includes('audio')) {
          setUnsupportedVideoAudioMessage(that.parent);
        }
      }
      else {
        setUnsupportedVideoCodecMessage(that.parent);
      }
      that.parent.onErrorPopUpClose = onErrorPopUpClose; // to remove videpo preview on error pop-up close
    }
  };

  const onReadyHandle = () => {
    if (instance.player.current && !instance.onReadyDone) {
      instance.player.current.seekTo(0.005, 'fraction'); // to avoid a black screen
      instance.onReadyDone = true;
    }
  };

  const onReadyHandleDummy = () => {
  };

  return (
    <div style = { styleObj } >
      <ReactPlayer className={`${videoClass}`} 
        playsinline
        url={url}
        controls
        muted={ muted }
        onError = { onErrorHandle }
        onReady = { (instance && !props.playing) ? onReadyHandle : onReadyHandleDummy }
        ref={ instance ? instance.player : null}
        {...props}
        config={config}
      />
    </div>
  );
}

export function onErrorPopUpClose(that) {
  if (that && that.ImageUploadder.current) {
    that.ImageUploadder.current.setState({ imageIsNotUploaded : true, videoPreviewUrl : '', file : '' });
    delete that.onErrorPopUpClose;
  }
};

export function renderVideoPlayerWrapperM(post, playing, loop, muted = true, config = {}) {
  let videoUrl = post.postVideo;
  let width;
  let height;
  let padding;
  let myPlaying = playing;
  let myMuted = muted;
  let widthString;
  let heightString;
  let videoClass = 'post-video';
  let styleObj;
  let playerRef = React.createRef(); 
  let instance = { player : playerRef, onReadyDone: false};
  let phoneMedia = window.matchMedia(Const.PHONE_MEDIA_INTERVAL);
  let postMediadescriptor = getPostMediaDescriptor(post);

  if (postMediadescriptor.deviceOrientation === 'portrait') {
    if (phoneMedia.matches) {
      padding = 1;
    }
    else {
      padding = 9;
    }
    width = postMediadescriptor.mediaWidth - padding * 2;
    height = width * (postMediadescriptor.mediaHeight / postMediadescriptor.mediaWidth);
  }
  else {
    width = postMediadescriptor.mediaWidth;
    height = postMediadescriptor.mediaHeight;
  }
  widthString = width + 'px';
  heightString = height + 'px';
  styleObj = { width: widthString, height: heightString, minHeight: heightString };
  if (playing && muted) {
    myPlaying = false;
    myMuted = false;
  }
  return renderVideoPlayer(videoUrl, styleObj, videoClass, myMuted, null, instance, config, { 
                            playing: myPlaying, 
                            loop: loop,
                            width: widthString,
                            height: heightString
                          });
}

export function renderVideoPlayerWrapperGB(post, playing, loop, muted = true, config = {}) {
  let videoUrl = post.postVideo;
  let width;
  let height;
  let myPlaying = playing;
  let myMuted = muted;
  let widthString;
  let heightString;
  let videoClass = '';
  let styleObj;
  let playerRef = React.createRef(); 
  let instance = { player : playerRef, onReadyDone: false};
  let postMediadescriptor = getPostMediaDescriptor(post);
  let dialogMaxHeight;
  let dialogMaxWidth;
  let phoneMedia = window.matchMedia(Const.PHONE_MEDIA_INTERVAL);
  let smallDevicesMedia = window.matchMedia(Const.SMALL_DEVICES_MEDIA_INTERVAL);
  let cssDimensions;

  if (isDesktop() && !smallDevicesMedia.matches) {
    width = postMediadescriptor.mediaWidth;
    height = postMediadescriptor.mediaHeight;
  }
  else if (postMediadescriptor.deviceOrientation === 'landscape') {
    dialogMaxHeight = window.innerHeight - 40 - 55; // replica of CSS 
    dialogMaxWidth = window.innerWidth / 2 - 10; // replica of CSS
    cssDimensions = getCSSdimensions(dialogMaxHeight, dialogMaxWidth, postMediadescriptor);
    height = cssDimensions.height;
    width = cssDimensions.width;
  }
  else if (phoneMedia.matches) {
    dialogMaxHeight = window.innerHeight - window.innerHeight / 5; // replica of CSS 
    dialogMaxWidth = window.innerWidth - 20; // replica of CSS
    cssDimensions = getCSSdimensions(dialogMaxHeight, dialogMaxWidth, postMediadescriptor);
    height = cssDimensions.height;
    width = cssDimensions.width;
  }
  else {
    dialogMaxHeight = window.innerHeight - 20; // replica of CSS 
    dialogMaxWidth = window.innerWidth * 0.7; // increased compared to CSS
    cssDimensions = getCSSdimensions(dialogMaxHeight, dialogMaxWidth, postMediadescriptor);
    height = cssDimensions.height;
    width = cssDimensions.width;
  }
  widthString = width + 'px';
  heightString = height + 'px';
  styleObj = { width:  widthString, height: heightString, maxHeight: heightString, maxWidth:  widthString };
  if (playing && muted) {
    myPlaying = false;
    myMuted = false;
  }
  return renderVideoPlayer(videoUrl, styleObj, videoClass, myMuted, null, instance, config, { 
                            playing: myPlaying, 
                            loop: loop,
                            width: widthString,
                            height: heightString
                          });
}

export function getCSSdimensions(dialogMaxHeight, dialogMaxWidth, postMediadescriptor) {
  let dialogHeighFromMaxWidth = dialogMaxWidth * postMediadescriptor.mediaHeight / postMediadescriptor.mediaWidth;
  let height = Math.min(dialogMaxHeight, dialogHeighFromMaxWidth);
  let cssDimensions = {
    height : height,
    width :  height * postMediadescriptor.mediaWidth / postMediadescriptor.mediaHeight
  }
  
  return cssDimensions;
}

export function renderVideoPlayerWrapperG(post, playing, loop, muted = true, config = {}) {
  let videoUrl = post.postVideo;
  let width;
  let height;
  let videoPortretHeight = getDynamicGaleryCellWidth(); 
  let koeff;
  let widthString;
  let heightString;
  let videoClass = '';
  let styleObj;
  let playerRef = React.createRef(); 
  let instance = { player : playerRef, onReadyDone: false};

  if (post.imgHeight > post.imgWidth) {
    koeff = post.imgWidth / post.imgHeight;
    height = videoPortretHeight;
    width = koeff * height;
    if ((window.innerWidth) <=  width) {
      width = window.innerWidth;
      height = koeff * width;
    }
    widthString = width + 'px';
    heightString = height + 'px';
  }
  else {
    koeff = post.imgHeight / post.imgWidth;
    if (isTabletLandscapeLayout()) {
      width = Const.POST_IMG_MAX_WIDTH_LENDSCAPE;
      height = width * koeff;
      widthString = width + 'px';
      heightString = height + 'px';
    }
    else {
      width = getDynamicGaleryCellWidth();
      height = width * koeff;
      widthString = width + 'px';
      heightString = height + 'px';
    }
  }
  styleObj = { width:  widthString, height: heightString };
  return renderVideoPlayer(videoUrl, styleObj, videoClass, muted, null, instance, config = {}, { 
                            playing: playing, 
                            loop: loop,
                            width: widthString,
                            height: heightString
                          });
}

export function renderVideoPlayerWrapperU(videoUrl, playing, loop, that, muted = true, config = {}) {
  let { file } = that.state;
  let videoClass = 'upload-video';
  let instance = null;
  let mediaUloadDimensions = that.getAvailableDimensionsForMediaUpLoad();
  let styleObj = {
    '--max-h': `${mediaUloadDimensions.height}px`,
    '--ratio': `${file.width} / ${file.height}`
  };

  if (!isiOSPlatform()) {
    styleObj['--max-w'] = '95%';
  }
  return renderVideoPlayer(videoUrl, styleObj, videoClass, muted, that, instance, config, { 
                            playing: playing, 
                            loop: loop,
                            width: 'unset', 
                            height: 'unset'
                          });
}

export function getDynamicGaleryCellWidth() {
  let mediaDeviceObj = getMatchingMediaDevice();
  let dynamicGaleryCellWidth = mediaDeviceObj.width; // 319

  return dynamicGaleryCellWidth;
}

export function getMatchingMediaDevice() {
  let phoneMedia = window.matchMedia(Const.PHONE_MEDIA_INTERVAL);
  let smallDevicesMedia = window.matchMedia(Const.SMALL_DEVICES_MEDIA_INTERVAL);
  let mediumDevicesMedia = window.matchMedia(Const.MEDIUM_DEVICES_INTERVAL);
  let largeDeviceMedia = window.matchMedia(Const.LARGE_DEVICES_INTERVAL);
  let xlargeDeviceMedia = window.matchMedia(Const.X_LARGE_DEVICES_INTERVAL);
  let mediaDeviceObj;
  let rootComputedWidthString = getComputedStyle(document.documentElement).width;
  let rootComputedWidthNumeric = parseFloat(rootComputedWidthString); // remove 'px'
  let koeff = isDesktop() ? 0.8 : 1;

  if (phoneMedia.matches) {
    mediaDeviceObj = {
      mediaDevice : Const.PHONE_MEDIA_DEVICE,
      width : (((rootComputedWidthNumeric * 1) * 0.33333) - 2)
    }
    console.log('root width --1', rootComputedWidthNumeric);
  }
  else if (smallDevicesMedia.matches) {
    // matches my laptop without monitor
    mediaDeviceObj = {
      mediaDevice : Const.SMALL_MEDIA_DEVICE,
      width : (((rootComputedWidthNumeric * koeff) * 0.33333) - 0.6)
    }
    console.log('root width --2', rootComputedWidthNumeric);
  }
  else if (mediumDevicesMedia.matches) {
    mediaDeviceObj = {
      mediaDevice : Const.MEDIUM_MEDIA_DEVICE,
      width : (((rootComputedWidthNumeric * 0.80) * 0.33333) - 0.6)
    }
    console.log('root width --3', rootComputedWidthNumeric);
  }
  else if (largeDeviceMedia.matches) {
     // matches Mac
    mediaDeviceObj = {
      mediaDevice : Const.LARGE_MEDIA_DEVICE,
      width : (((rootComputedWidthNumeric * 0.65) * 0.33333) - 0.6)
    }
    console.log('root width --4', rootComputedWidthNumeric);
  }
  else if (xlargeDeviceMedia.matches) {
   mediaDeviceObj = {
     mediaDevice : Const.X_LARGE_MEDIA_DEVICE,
     width : (((rootComputedWidthNumeric * 0.7) * 0.33333) - 0.6)
   }
   console.log('root width --5', rootComputedWidthNumeric);
 }
  return mediaDeviceObj
}